import { useState, useEffect } from "react"
import { Link } from "react-router-dom"

import useFlashMessage from '../../../hooks/useFlashMessage'

//functions
import NumberToMoney from '../../../shared/functions/NumberToMoney'
import findClothPurchaseRule from '../../../shared/functions/findClothPurchaseRule'
import api from '../../../utils/api'
import "../Product.css"
import "./FormProduct.css"
/* form */
import Input from "../../../shared/components/form/input"
/* form select */
import Select from 'react-select'
import selectStyles from "../../../shared/css/SelectStyle"
/* modal */
import Modal from "../../../shared/modal/Modal"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
/* Commission */
import Commission from "../../Commission/Commission"
/* Aditivo */
import Additive from "../../Additive/Additive"
/* Aviamento */
import Aviamento from "../../aviamento/Aviamento"
/* Cadastro rápido: fornecedor, tecido, categoria e grade */
import NewProvider from "../../provider/NewProvider"
import NewCloth from "../../cloth/NewCloth"
import NewCategory from "../../category/NewCategory"
import NewSizeGrid from "../../SizeGrid/NewSizeGrid"
function FormProduct({ productData, additiveData, aviamentosData, additionalSizeData, commissionData, handleSubmit, gridData, title, btnCancelLink, btnText, btCancelAction }) {
    const productDefault = {
        labor: "0.00",
        cost: "0.00",
        inCash: "70",
        instalment: "80",
        percentOfSale: "100",
        measure: "1.00",
        sex: { name: "sex", value: "M", label: "Masculino" },
        gridType: "shirt"

    }

    const { setFlashMessage } = useFlashMessage()
    const [token] = useState(localStorage.getItem('token') || '')
    const [product, setProduct] = useState(productData || productDefault)
    /* fornecedor */
    const [providers, setProviders] = useState([])
    const [categories, setCategories] = useState([])

    const [cloths, setCloths] = useState([])

    const [sizeGrids, setSizeGrids] = useState([])
    const [commissions, setCommissions] = useState([])
    const [selectedGrid, setSelectedGrid] = useState(gridData || [])


    const [additive, setAdditive] = useState(additiveData || [])
    // aviamentosData vem do backend como [{ aviamento: {_id,name,unit,...}, quantityPerPiece }] —
    // achatado aqui pra um array de {_id,name,unit,quantityPerPiece}, mais fácil de editar no chip row.
    const [aviamentos, setAviamentos] = useState(
        (aviamentosData || []).filter((a) => a.aviamento).map((a) => ({ ...a.aviamento, quantityPerPiece: a.quantityPerPiece }))
    )
    const [additionalSize, setAdditionalSize] = useState(additionalSizeData || [])
    const [commission, setCommission] = useState(commissionData || [])

    const [modalAdditive, setModalAdditive] = useState(false)
    const [modalAviamento, setModalAviamento] = useState(false)

    const [modalCommission, setModalCommission] = useState(false)

    /* Cadastro rápido de fornecedor, tecido, categoria e grade */
    const [modalProvider, setModalProvider] = useState(false)
    const [modalCloth, setModalCloth] = useState(false)
    const [modalCategory, setModalCategory] = useState(false)
    const [modalSizeGrid, setModalSizeGrid] = useState(false)

    const getSelectInfo = () => {
        api.get('/product/getInfoSelect', {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        })
            .then((response) => {
                setCloths(response.data.cloths)
                setProviders(response.data.providers)
                setCommissions(response.data.commissions)
                setSizeGrids(response.data.sizeGrids)
                setCategories(response.data.categories)


            })
    }

    useEffect(() => {
        getSelectInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    // A unidade (kg/metro) do Produto nunca é escolhida manualmente — vem sempre da regra de
    // compra cadastrada no Fornecedor pra esse Tecido, pra nunca ficar vaga/inconsistente.
    useEffect(() => {
        if (!product.provider || !product.cloth) return
        const rule = findClothPurchaseRule(product.provider, product.cloth._id)
        setProduct((prev) => ({ ...prev, unit: rule ? rule.unit : null }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product.provider, product.cloth])

    const clothRule = (product.provider && product.cloth)
        ? findClothPurchaseRule(product.provider, product.cloth._id)
        : null

    // O Tecido só pode ser um dos que o Fornecedor escolhido realmente tem regra de compra
    // cadastrada — mostra a unidade de cada um no rótulo, pra já ficar claro antes de escolher.
    const availableCloths = product.provider
        ? cloths
            .map((c) => ({ cloth: c, rule: findClothPurchaseRule(product.provider, c._id) }))
            .filter((x) => x.rule)
            .map((x) => ({ ...x.cloth, label: `${x.cloth.name} (${x.rule.unit.label})` }))
        : []

    function handleChange(e) {
        setProduct({ ...product, [e.target.name]: e.target.value })


    }
    const descriptionText = () => {
        let text = ""
        if (product.provider) {
            text = text + product.provider.label
        }
        if (product.category) {
            text = text + " " + product.category.label
        }
        if (product.cloth) {
            text = text + " " + product.cloth.label
        }
        if (product.sex) {
            text = text + " " + product.sex.label
        }
        return text
    }

    /*  update additive */
    function updateAdditive(data) {
        setAdditive(data)

    }
    function handleChangeMoneyAdditive(e) {

        let value = NumberToMoney(e.target.value)

        setAdditive({ ...additive, [e.target.name]: value })


    }
    /* Addicional Size */
    function handleChangeAddicionalSize(e) {

        setAdditionalSize({ ...additionalSize, [e.target.name]: e.target.value })
    }
    function handleChangeMoneyAddicionalSize(e) {

        let value = NumberToMoney(e.target.value)

        setAdditionalSize({ ...additionalSize, [e.target.name]: value })


    }
    /* update Commission */
    const handleOnSelectItemCommission = (data) => {
        setCommission(data)
    }
    const handleOnSelectItemAdditive = (data) => {
        setAdditive(data)
    }
    /* update Aviamento — o picker (Aviamento.js em modo selectItem) só sabe selecionar/deselecionar;
       a quantidade por peça é mantida aqui fora, preservando o valor já digitado pros itens que
       continuam selecionados. */
    const handleOnSelectItemAviamento = (data) => {
        setAviamentos(data.map((item) => {
            const existing = aviamentos.find((a) => a._id === item._id)
            return { ...item, quantityPerPiece: existing ? existing.quantityPerPiece : '' }
        }))
    }
    function handleChangeAviamentoQuantity(id, value) {
        setAviamentos(aviamentos.map((a) => a._id === id ? { ...a, quantityPerPiece: value } : a))
    }
    function removeAviamento(id) {
        setAviamentos(aviamentos.filter((a) => a._id !== id))
    }





    /* ------------------------------------- SELECT ---------------------------------------- */
    /* estilo do select */



    const handleSelectChange = (selectedOption) => {

        if (selectedOption.selectName === "provider") {
            // Trocar o fornecedor invalida o tecido escolhido antes — a lista de tecidos
            // disponíveis depende de qual fornecedor está selecionado.
            setProduct({ ...product, provider: selectedOption, cloth: null, color: {}, ref: "" })
        } else if (selectedOption.selectName === "cloth") {
            setProduct({ ...product, cloth: selectedOption, color: {}, ref: "" })
        } else if (selectedOption.selectName === "color") {
            setProduct({ ...product, [selectedOption.selectName]: selectedOption })
        } else if (selectedOption.selectName === "sizeGrid") {
            setSelectedGrid(selectedOption.grid)
            setProduct({ ...product, [selectedOption.selectName]: selectedOption })
        } else {
            setProduct({ ...product, [selectedOption.selectName]: selectedOption })
        }

    }
    /* --------------------------- select Fornecedor, tecido e cores ---------------------------------------- */




    /* Select options Colors */
    /*    let optionsColors
       if (colors) {
           if (product.provider && product.cloth) {
               optionsColors = colors.filter((item) => item.provider.value === product.provider.id && item.cloth.value === product.cloth.value)
   console.log(colors)

           } else {
               optionsColors = []
           }
       } */


    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {

        let value = NumberToMoney(e.target.value)

        setProduct({ ...product, [e.target.name]: value })


    }


    /* ------------------------------------------ Radio ---------------------------------------- */
    const handleChangeRadio = (name, value) => {

        setProduct({ ...product, [name]: value })
    }
    /* --------------------------------------- function calc price ----------------------------- */
    const priceCalc = (percent) => {
        let price = 0
        if (product.unit) {

            if (product.unit.value === "m") {
                price = (((parseFloat(product.cost) * parseFloat(product.measure)) + parseFloat(product.labor)) * (1 + parseFloat(percent) / 100)) * (1 + parseFloat(product.percentOfSale) / 100)

            } else if (product.unit.value === "kg") {
                price = (((parseFloat(product.cost) / parseFloat(product.measure)) + parseFloat(product.labor)) * (1 + parseFloat(percent) / 100)) * (1 + parseFloat(product.percentOfSale) / 100)
            }

        }
        return NumberToMoney(price)
    }

    /* -------------------------------------- Submit --------------------------------------- */
    function submit() {

        if (!product.provider || !product.cloth) {
            setFlashMessage('Selecione o fornecedor e o tecido', 'error')
            return
        }
        if (!clothRule) {
            setFlashMessage('Esse fornecedor não tem uma regra de compra cadastrada para esse tecido — cadastre a unidade (kg/metro) no Fornecedor antes de continuar', 'error')
            return
        }

        let data = product
        data.unit = clothRule.unit
        let additives = []
        if (additive.length) {
            additives = additive.map((i) => {
                return i._id
            })
        }
        let comm = []
        if (commission.length) {
            comm = commission.map((i) => {
                return i._id
            })
        }
        data.additive = additives
        data.aviamentos = aviamentos.map((a) => ({ aviamento: a._id, quantityPerPiece: a.quantityPerPiece }))
        data.commissions = comm
        data.additionalSize = additionalSize
        data.totalInCash = priceCalc(product.inCash)
        data.totalInstalment = priceCalc(product.instalment)
        data.description = descriptionText()
        handleSubmit(data)

    }

    /* --------------------------------- page ------------------------------------------ */
    return (
        <FormLayout
            title={title}
            actions={
                <>
                    <Button variant="save" onClick={submit}>Salvar</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Identificação">
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Código"
                            type="text"
                            name="code"
                            disabled={true}
                            handleOnChange={handleChange}
                            value={product.code || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Fornecedor:
                            <div onClick={() => { setModalProvider(true) }} >
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <Select
                            options={providers}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={product.provider || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Tecido:
                            <div onClick={() => { setModalCloth(true) }}>
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <Select
                            options={availableCloths}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={product.cloth ? (availableCloths.find((c) => c._id === product.cloth._id) || product.cloth) : ""}
                            isDisabled={!product.provider}
                            placeholder={product.provider ? "Selecione..." : "Selecione um fornecedor primeiro"}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                        {product.provider && availableCloths.length === 0 && (
                            <span className="fp-unit-error">Esse fornecedor não tem nenhum tecido com regra de compra cadastrada</span>
                        )}
                    </div>
                </div>

                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Categoria:
                            <div onClick={() => { setModalCategory(true) }}>
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <Select
                            options={categories}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={product.category || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Sexo:</label>
                        <Select
                            options={[
                                { selectName: "sex", value: "M", label: "Masculino" },
                                { selectName: "sex", value: "F", label: "Feminino" },
                                { selectName: "sex", value: "M&F", label: "Masculino e Feminino" },
                            ]}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={product.sex || { selectName: "sex", value: "M", label: "Masculino" }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>

                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Descrição"
                            type="text"
                            name="description"
                            placeholder="digite uma descrição"
                            handleOnChange={handleChange}
                            value={descriptionText()}
                            disabled={true}
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label={<>Aditivo <span className="fl-section-optional">(opcional)</span></>}>
                <label className="input-label">Selecionar aditivos:
                    <div onClick={() => { setModalAdditive(true) }} >
                        <div className="plus-sinal" >
                            <div className="plus-sinal-tip"></div>
                            <div className="plus-sinal-middle"></div>
                            <div className="plus-sinal-tip"></div>
                        </div>
                    </div>
                </label>
                {additive.length > 0 ? (
                    <div className="fp-chip-row">
                        {additive.map((item) => (
                            <span className="fp-chip" key={item._id}>
                                {item.name} <strong>R$ {NumberToMoney(item.price)}</strong>
                            </span>
                        ))}
                    </div>
                ) : (
                    <div className="fp-empty">Nenhum aditivo selecionado.</div>
                )}
                <Modal
                    modalStatus={modalAdditive}
                    changeStatus={setModalAdditive}
                    w={40}
                    content={
                        <Additive selectItem={true} handleOnSelectItem={handleOnSelectItemAdditive} selectedData={additive} />
                    }
                />
            </FormSection>

            <FormSection label={<>Aviamento <span className="fl-section-optional">(opcional)</span></>}>
                <label className="input-label">Selecionar aviamentos:
                    <div onClick={() => { setModalAviamento(true) }} >
                        <div className="plus-sinal" >
                            <div className="plus-sinal-tip"></div>
                            <div className="plus-sinal-middle"></div>
                            <div className="plus-sinal-tip"></div>
                        </div>
                    </div>
                </label>
                {aviamentos.length > 0 ? (
                    <div className="fp-chip-row">
                        {aviamentos.map((item) => (
                            <span className="fp-chip" key={item._id}>
                                {item.name}
                                <input
                                    className="fp-chip-qty-input"
                                    type="number"
                                    step="any"
                                    placeholder="qtd"
                                    value={item.quantityPerPiece}
                                    onChange={(e) => handleChangeAviamentoQuantity(item._id, e.target.value)}
                                />
                                <span className="fp-chip-sep">{item.unit?.label || item.unit?.value}</span>
                                <span className="fp-chip-remove" onClick={() => removeAviamento(item._id)}>×</span>
                            </span>
                        ))}
                    </div>
                ) : (
                    <div className="fp-empty">Nenhum aviamento selecionado.</div>
                )}
                <Modal
                    modalStatus={modalAviamento}
                    changeStatus={setModalAviamento}
                    w={40}
                    content={
                        <Aviamento selectItem={true} handleOnSelectItem={handleOnSelectItemAviamento} selectedData={aviamentos} />
                    }
                />
            </FormSection>

            <FormSection label="Grade e Adicional de Tamanho">
                <label className="input-label">Selecionar grade:
                    <div onClick={() => { setModalSizeGrid(true) }}>
                        <div className="plus-sinal" >
                            <div className="plus-sinal-tip"></div>
                            <div className="plus-sinal-middle"></div>
                            <div className="plus-sinal-tip"></div>
                        </div>
                    </div>
                </label>
                <Select
                    options={sizeGrids}
                    styles={selectStyles}
                    onChange={handleSelectChange}
                    value={product.sizeGrid || ""}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                />
                {selectedGrid && selectedGrid.length > 0 ? (
                    <div className="fp-chip-row">
                        {selectedGrid.map((i, idx) => (
                            <span className="fp-chip" key={i._id || idx}>
                                {i.name} <strong>R$ {NumberToMoney(i.price)}</strong>
                            </span>
                        ))}
                    </div>
                ) : (
                    <div className="fp-empty">Nenhuma grade selecionada.</div>
                )}
            </FormSection>

            <FormSection label="Comissão e Desconto">
                <label className="input-label">Selecionar comissão e desconto:
                    <div onClick={() => { setModalCommission(true) }}>
                        <div className="plus-sinal" >
                            <div className="plus-sinal-tip"></div>
                            <div className="plus-sinal-middle"></div>
                            <div className="plus-sinal-tip"></div>
                        </div>
                    </div>
                </label>
                {commission.length > 0 ? (
                    <div className="fp-chip-row">
                        {commission.map((item) => (
                            <span className="fp-chip" key={item._id}>
                                Com. {item.commission}% <span className="fp-chip-sep">·</span> Desc. {item.discount}%
                            </span>
                        ))}
                    </div>
                ) : (
                    <div className="fp-empty">Nenhuma comissão selecionada.</div>
                )}
                <Modal
                    modalStatus={modalCommission}
                    changeStatus={setModalCommission}
                    w={40}
                    content={
                        <Commission selectItem={true} handleOnSelectItem={handleOnSelectItemCommission} selectedData={commission} />
                    }
                />
            </FormSection>

            {/* MODAIS DE CADASTRO RÁPIDO */}
            <Modal
                modalStatus={modalProvider}
                changeStatus={setModalProvider}
                w={80}
                content={
                    <NewProvider btCancelAction={() => setModalProvider(false)} handleOnSuccess={() => { setModalProvider(false); getSelectInfo() }} />
                }
            />
            <Modal
                modalStatus={modalCloth}
                changeStatus={setModalCloth}
                w={80}
                content={
                    <NewCloth btCancelAction={() => setModalCloth(false)} handleOnSuccess={() => { setModalCloth(false); getSelectInfo() }} />
                }
            />
            <Modal
                modalStatus={modalCategory}
                changeStatus={setModalCategory}
                w={80}
                content={
                    <NewCategory btCancelAction={() => setModalCategory(false)} handleOnSuccess={() => { setModalCategory(false); getSelectInfo() }} />
                }
            />
            <Modal
                modalStatus={modalSizeGrid}
                changeStatus={setModalSizeGrid}
                w={80}
                content={
                    <NewSizeGrid btCancelAction={() => setModalSizeGrid(false)} handleOnSuccess={() => { setModalSizeGrid(false); getSelectInfo() }} />
                }
            />

            <FormSection label="Precificação">
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Custo"
                            type="number"
                            name="cost"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={product.cost}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Medida"
                            type="number"
                            name="measure"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={product.measure}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <label className="input-label">Unidade:</label>
                        {!product.provider || !product.cloth ? (
                            <span className="fl-section-hint">Selecione fornecedor e tecido</span>
                        ) : clothRule ? (
                            <div className="fp-unit-readonly">{clothRule.unit.label}</div>
                        ) : (
                            <span className="fp-unit-error">Sem regra de compra cadastrada pra esse fornecedor+tecido</span>
                        )}
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Mão de Obra"
                            type="number"
                            name="labor"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={product.labor}
                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="% Á Vista"
                            type="number"
                            name="inCash"
                            handleOnChange={handleChange}
                            value={product.inCash}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="% Parcelado"
                            type="number"
                            name="instalment"
                            handleOnChange={handleChange}
                            value={product.instalment}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="% de venda"
                            type="number"
                            name="percentOfSale"
                            handleOnChange={handleChange}
                            value={product.percentOfSale}
                        />
                    </div>
                </div>

                <div className="fp-totals">
                    <div className="fp-total-tile">
                        <span className="fp-total-label">Á vista</span>
                        <span className="fp-total-value">R$ {priceCalc(product.inCash)}</span>
                    </div>
                    <div className="fp-total-tile">
                        <span className="fp-total-label">Parcelado</span>
                        <span className="fp-total-value">R$ {priceCalc(product.instalment)}</span>
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormProduct
